import React, { FunctionComponent, useState } from 'react';
import { Box, Text } from 'rebass/styled-components';
import { Heading, Button } from '..';
import { ConfirmModal } from '../modal';

const copyText = require('./copy-text.json');

const {
  USER_INTEGRATION_CREDENTIALS_REFRESH_CONFIRM_TITLE,
  USER_INTEGRATION_CREDENTIALS_REFRESH_CONFIRM_DETAIL,
} = copyText;

export interface UserIntegrationCredentialsButtonProps {
  username: string;
  isLoadingUsername: boolean;
  isLoadingCreate: boolean;
  onClickCreateIntegrationUser: () => void;
  recycleIntegrationUser: () => void;
}

const UserIntegrationCredentialsButton: FunctionComponent<
UserIntegrationCredentialsButtonProps> = ({
  username, isLoadingCreate, isLoadingUsername,
  onClickCreateIntegrationUser, recycleIntegrationUser,
}: UserIntegrationCredentialsButtonProps) => {
  const [isShowConfirmModal, setShowConfirmModal] = useState<boolean>(false);

  const handleClickReset = () => {
    setShowConfirmModal(true);
  };

  const handleReset = () => {
    setShowConfirmModal(false);
    recycleIntegrationUser();
  };

  const handleCancel = () => {
    setShowConfirmModal(false);
  };

  if (isLoadingUsername) {
    return null;
  }

  return !username ? (
    <Button
      variant="primary"
      onClick={onClickCreateIntegrationUser}
      data-testid="create-integration-user-button"
      disabled={!!isLoadingCreate}
    >
      Generate User
    </Button>
  ) : (
    <>
      <Button
        variant="tertiary"
        onClick={handleClickReset}
        data-testid="refresh-integration-user-button"
        disabled={!!isLoadingCreate}
      >
        Reset Credentials
      </Button>
      <ConfirmModal
        show={isShowConfirmModal}
        confirmText="Yes, reset"
        cancelText="Cancel"
        onCancel={handleCancel}
        onConfirm={handleReset}
        title={USER_INTEGRATION_CREDENTIALS_REFRESH_CONFIRM_TITLE}
        detail={USER_INTEGRATION_CREDENTIALS_REFRESH_CONFIRM_DETAIL}
      />
    </>
  );
};

export default UserIntegrationCredentialsButton;
